import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const VendorList = () => {
    const [vendors, setVendors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    // Fetch vendors from the API
    useEffect(() => {
        fetch('http://localhost:8000/api/vendors')
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'success') {
                    setVendors(data.data);
                } else {
                    throw new Error('Failed to fetch vendors');
                }
            })
            .catch((err) => setError(err.message))
            .finally(() => setLoading(false));
    }, []);

    // Navigate to Add Vendor page
    const handleAddVendor = () => {
        navigate('/AddVendor');
    };

    // Navigate to Edit Vendor page
    const handleEditVendor = (id) => {
        navigate(`/EditVendor/${id}`);
    };

    // Handle Vendor Deletion
    const handleDeleteVendor = (id) => {
        if (window.confirm("Are you sure you want to delete this vendor?")) {
            fetch(`http://localhost:8000/api/vendors/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 'success') {
                        // Remove the deleted vendor from the list
                        setVendors(vendors.filter(vendor => vendor.id !== id));
                    } else {
                        alert('Failed to delete the vendor');
                    }
                })
                .catch(error => {
                    console.error('Error deleting vendor:', error);
                    alert('Failed to delete the vendor');
                });
        }
    };

    if (loading) {
        return <p>Loading vendors...</p>;
    }

    if (error) {
        return <p>Error: {error}</p>;
    }

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Vendor List</h3>
                            <p className="text-subtitle text-muted">List of all vendors</p>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Vendors</h4>
                                <button className="btn btn-primary" onClick={handleAddVendor}>
                                    Add Vendor
                                </button>
                            </div>
                            <div className="card-body">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>GST No</th>
                                            <th>Name</th>
                                            <th>Print Name</th>
                                            <th>Identification</th>
                                            <th>Code</th>
                                            <th>Contact</th>
                                            <th>GST</th>
                                            <th>Registration Date</th>
                                            <th>CIN</th>
                                            <th>PAN</th>
                                            <th>GST Category</th>
                                            <th>GST Suspend</th>
                                            <th>Distance</th>
                                            <th>TDS on GST</th>
                                            <th>Address</th>
                                            <th>Country</th>
                                            <th>State</th>
                                            <th>City</th>
                                            <th>Pin Code</th>
                                            <th>Phone</th>
                                            <th>Email</th>
                                            <th>Longitude</th>
                                            <th>Latitude</th>
                                            <th>Website</th>
                                            <th>Facebook</th>
                                            <th>Skype</th>
                                            <th>Twitter</th>
                                            <th>LinkedIn</th>
                                            <th>Payment Term</th>
                                            <th>Price Category</th>
                                            <th>Agent/Broker</th>
                                            <th>Transporter</th>
                                            <th>Credit Limit</th>
                                            <th>Max Credit Days</th>
                                            <th>Interest Rate (Yearly)</th>
                                            <th>LFSC RTGS Code</th>
                                            <th>Account Number</th>
                                            <th>Bank Name</th>
                                            <th>Branch</th>
                                            <th>Attachment</th>
                                            <th>Created At</th>
                                            <th>Updated At</th>
                                            <th>Actions</th> {/* New column for actions */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {vendors.map((vendor) => (
                                            <tr key={vendor.id}>
                                                <td>{vendor.id}</td>
                                                <td>{vendor.gst_no}</td>
                                                <td>{vendor.name}</td>
                                                <td>{vendor.print_name}</td>
                                                <td>{vendor.identification}</td>
                                                <td>{vendor.code}</td>
                                                <td>{vendor.contact}</td>
                                                <td>{vendor.gst}</td>
                                                <td>{new Date(vendor.registration_date).toLocaleDateString()}</td>
                                                <td>{vendor.cin}</td>
                                                <td>{vendor.pan}</td>
                                                <td>{vendor.gst_category}</td>
                                                <td>{vendor.gst_suspend}</td>
                                                <td>{vendor.distance}</td>
                                                <td>{vendor.tds_on_gst}</td>
                                                <td>{vendor.address}</td>
                                                <td>{vendor.country}</td>
                                                <td>{vendor.state}</td>
                                                <td>{vendor.city}</td>
                                                <td>{vendor.pin_code}</td>
                                                <td>{vendor.phone}</td>
                                                <td>{vendor.email}</td>
                                                <td>{vendor.longitude}</td>
                                                <td>{vendor.latitude}</td>
                                                <td><a href={vendor.website} target="_blank" rel="noopener noreferrer">{vendor.website}</a></td>
                                                <td>{vendor.facebook}</td>
                                                <td>{vendor.skype}</td>
                                                <td>{vendor.twitter}</td>
                                                <td>{vendor.linkedin}</td>
                                                <td>{vendor.payment_term}</td>
                                                <td>{vendor.price_category}</td>
                                                <td>{vendor.agent_broker}</td>
                                                <td>{vendor.transporter}</td>
                                                <td>{vendor.credit_limit}</td>
                                                <td>{vendor.max_credit_days}</td>
                                                <td>{vendor.interest_rate_yearly}</td>
                                                <td>{vendor.lfsc_rtgs_code}</td>
                                                <td>{vendor.account_number}</td>
                                                <td>{vendor.bank_name}</td>
                                                <td>{vendor.branch}</td>
                                                <td>
                                                    <a href={`http://localhost:8000/${vendor.attachment}`} target="_blank" rel="noopener noreferrer">
                                                        View Attachment
                                                    </a>
                                                </td>
                                                <td>{new Date(vendor.created_at).toLocaleString()}</td>
                                                <td>{new Date(vendor.updated_at).toLocaleString()}</td>
                                                <td>
                                                    {/* Edit and Delete Buttons */}
                                                    <button
                                                        className="btn btn-warning btn-sm"
                                                        onClick={() => handleEditVendor(vendor.id)}
                                                    >
                                                        Edit
                                                    </button>
                                                    <button
                                                        className="btn btn-danger btn-sm ms-2"
                                                        onClick={() => handleDeleteVendor(vendor.id)}
                                                    >
                                                        Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default VendorList;
